<template>
  <div>
    <topback title="Modify password" path="back"></topback>
    <div class="register" style="margin-top: 1.2rem;">
      <div class="heading">
        <h1>
          <span>{{ app_title }}</span>
        </h1>
        <img src="/static/images/avatar.png" class="logo" />
        <h3>Modify password Form</h3>
      </div>
      <div class="registerform">
        <md-field>
          <input-validate
            ref="phone"
            title="phone"
            type="phone"
            name="phone"
            v-model="phone"
            placeholder="Enter phone"
            v-validate="'phone'"
            data-vv-value-path="innerValue"
            data-vv-validate-on="blur"
            align="right"
            :error="errors.first('phone')"
          ></input-validate>

          <input-validate
            ref="password"
            title="Password"
            type="password"
            name="password"
            v-model="password"
            placeholder="Enter password"
            v-validate="'required|password'"
            data-vv-value-path="innerValue"
            data-vv-validate-on="blur"
            align="right"
            :error="errors.first('password')"
          ></input-validate>
          <input-validate
            title="Confirm"
            type="password"
            name="repassword"
            v-model="repassword"
            placeholder="Password, Again"
            v-validate="'required|confirmed:password'"
            data-vv-as="password"
            align="right"
            :error="errors.first('repassword')"
          ></input-validate>
        </md-field>
      </div>
      <md-button
        class="primary registerbtn"
        @click="registerClick"
        :loading="loading"
        >Modify</md-button
      >
      <md-captcha
        ref="captcha"
        v-model="show"
        :title="title"
        :maxlength="limit ? parseFloat(maxlength) : -1"
        :system="system"
        :mask="mask"
        :appendTo="appendTo"
        :autoCountdown="true"
        :count="120"
        count-normal-text="ReSend OTP"
        count-active-text="Resend in {$1} seconds"
        @submit="submit"
        @show="onShow"
        @hide="onHide"
        @send="onSend"
      >
        {{ content }}
      </md-captcha>
    </div>
    <div v-if="cf_turnstile_sitekey" style="display:none ;">
      <vue-turnstile
        :site-key="cf_turnstile_sitekey"
        @verified="token = $event"
      />
    </div>
    <Loading :isloading="isLoading"></Loading>
  </div>
</template>

<script>
import inputValidate from "@/components/input-validate";
import topback from "@/components/topback";
import { Validator } from "vee-validate";
import { sendsms, resetpassword, getsiteconfig, cftoken } from "@/request/api";
import VueTurnstile from "@gaviti/vue-turnstile";
import Loading from "@/components/Loadingsaly.vue";

Validator.extend("phone", {
  getMessage: field => `${field} value do not meet right format`,
  validate: value => /^\d{10}$/.test(value)
});

Validator.extend("password", {
  getMessage: field => `${field} at least 6 digits`,
  validate: value => /^\S{6,}$/.test(value)
});

export default {
  name: "editpassword",
  components: {
    inputValidate,
    topback,
    VueTurnstile,
    Loading
  },

  data() {
    return {
      show: false,
      appendTo: document.body,
      title: "Please enter OTP",
      content: "",
      limit: true,
      maxlength: "4",
      mask: false,
      system: false,
      invitercode: "",
      loading: false,
      sendtoken: "",
      phone: "",
      password: "",
      repassword: "",
      token: "",
      isLoading: true,
      sendtoken: "",
      cf_turnstile_sitekey: ""
    };
  },
  created() {
    this.app_title = process.env.VUE_APP_TITLE;
    this.phone = this.$store.state.userinfo.phone;
    this.cf_turnstile_sitekey = localStorage.getItem("cf_key") || "";

    setTimeout(() => {
      if (this.token === "") {
        location.reload();
      }
    }, 8000);

    if (!localStorage.getItem("cf_key")) {
      getsiteconfig().then(res => {
        if (res.code === 200) {
          this.cf_turnstile_sitekey = res.data.cf_turnstile_sitekey;
          localStorage.setItem("cf_key", res.data.cf_turnstile_sitekey);
        }
      });
    }
    this.$watch("token", (newValue, oldValue) => {
      if (newValue) {
        this.isLoading = false; // 如果 token 有值，则关闭加载动画
      } else {
        this.isLoading = true; // 如果 token 为空，则显示加载动画
      }
    });

    setTimeout(() => {
    if (!this.token) {
      window.location.reload();
    }
  }, 7000);
  },
  methods: {
    registerClick() {
      let that = this;
      this.$validator.validateAll().then(res => {
        if (res) {
          that.content =
            "OTP sent to " +
            that.phone.slice(0, 3) +
            "****" +
            that.phone.slice(that.phone.length - 4, that.phone.length);
          this.show = true;
        }
      });
    },
    onSend() {
      this.$refs.captcha.setError();
  

      if (!this.token) {
        this.$refs.captcha.setError("Unsafe environment");
        return;
      }

      cftoken({ token: this.token }).then(res => {
        if (res.code == 200) {
          this.sendtoken = res.data.sendtoken;
          sendsms({
            phone: this.phone,
            sendtoken: this.sendtoken,
            purpose: "forgotpassword"
          })
            .then(res => {
              if (res.code !== 200) {
                this.$refs.captcha.setError(res.errmsg);
                this.$refs.captcha.resetcount();
                this.sendtoken = "";
              }
            })
            .catch(error => {
              this.$refs.captcha.setError("Failed to send OTP, please resend");
              this.$refs.captcha.resetcount();
              this.sendtoken = "";
            });
        } else {
          this.$refs.captcha.setError("Security check failed");
        }
      });
    },
    onShow() {},
    onHide() {
      this.$refs.captcha.setError();
    },
    submit(val) {
      const max = parseFloat(this.maxlength);
      setTimeout(() => {
        if (!this.limit || max < 0 || val.length === max) {
          this.$toast.loading("Processing...");
          resetpassword({
            phone: this.phone,
            password: this.password,
            sendtoken: this.sendtoken,
            smscode: val
          }).then(res => {
            this.$toast.hide();
            if (res.code === 200) {
              this.$toast.succeed("Successfully modify");
              let that = this;
              setTimeout(() => {
                localStorage.removeItem("token");
                that.$router.push("/login");
              }, 1000);
            } else {
              this.$refs.captcha.setError(res.errmsg);
            }
          });
        }
      }, 300);
    },
    go_login() {
      this.$router.push("/login");
    },
    guid() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }

      return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
    }
  }
};
</script>

<style scoped>
.logo {
  width: 1.75rem;
}

.register {
  margin-top: 0.7rem;
}

.register-footer {
  font-size: 0.26rem;
  color: gray;
}

.heading {
  text-align: center;
  margin-bottom: 48px;
}

.heading h1 {
  color: #333;
  line-height: 1.15;
  font-size: 64px;
  margin-bottom: 32px;
}

.heading h3 {
  color: #333;
  line-height: 1.15;
  font-size: 32px;
  margin-bottom: 32px;
}

.heading h1 span {
  position: relative;
}

.heading h1 span::after {
  content: "";
  position: absolute;
  z-index: -1;
  left: 0;
  bottom: 8px;
  width: 100%;
  height: 20px;
  background: #ecf6ff;
}

.registerbtn {
  margin-top: 2.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/editpassword.vue